'use client'

import {observer} from 'mobx-react'

import {useLayoutStore} from '@/src/shared/ui/layout/ui/provider'

export const LicenseAgreement = observer(
  ({btnName, text, linkText}: {btnName?: string; text?: React.ReactNode; linkText?: string}) => {
    const layoutStore = useLayoutStore()

    return (
      <div>
        {(text && text) || <>Нажимая на кнопку &quot;{btnName}&quot;, вы принимаете условия </>}
        <a href={layoutStore.data.forms.user_agreement_url}>{linkText ?? 'Пользовательского соглашения'}</a>.
      </div>
    )
  },
)

export const PersonalAgreement = observer(({text, linkText}: {text: React.ReactNode; linkText?: string}) => {
  const layoutStore = useLayoutStore()

  return (
    <div>
      {text}&nbsp;
      <a href={layoutStore.data.forms.privacy_policy_url ?? '#'}>{linkText ?? 'Правила обработки'}</a>.
    </div>
  )
})
